// @flow
import {isEqual} from 'lodash';
import React, {Children, cloneElement, PureComponent} from 'react';
import type {Node} from 'react';
import type {MarkerSymbol} from './helpers';
type Props = {
    children?: Node,
    icon: MarkerSymbol,
    isHighlighted: boolean,
    listingId: string,
    map: Object, // google maps map object
    onClick: (string) => void,
    position: Object, // google maps latlng object
    zIndex?: number
};

export default class Marker extends PureComponent<Props> {
    marker: Object;

    constructor(props: Props) {
        super();

        const {icon, listingId, onClick, map, position} = props;
        const marker = new google.maps.Marker({
            position,
            map,
            icon,
            zIndex: props.zIndex || 1
        });

        /* istanbul ignore next */
        google.maps.event.addListener(marker, 'click', () => {
            onClick(listingId);
        });

        this.marker = marker;
    }

    componentDidUpdate(prevProps: Props) {
        if (!isEqual(prevProps.icon, this.props.icon)) {
            this.marker.setIcon(this.props.icon);
        }

        // if the marker is highlighted move it above the others
        if (
            typeof this.props.isHighlighted !== 'undefined' &&
            prevProps.isHighlighted !== this.props.isHighlighted
        ) {
            const z = this.props.isHighlighted
                ? google.maps.Marker.MAX_ZINDEX + 1
                : 1;
            this.marker.setZIndex(z);
        }
    }

    componentWillUnmount() {
        // remove all marker listeners
        google.maps.event.clearListeners(this.marker, 'click');

        // remove marker
        this.marker.setMap(null);
    }

    render() {
        const {children, map} = this.props;
        if (children) {
            const childrenWithMarker = Children.map(children, (child) =>
                cloneElement(child, {
                    map,
                    marker: this.marker
                })
            );

            return (
                <div className={'MapHitMarkerHighlighted'}>
                    {childrenWithMarker}
                </div>
            );
        }

        return null;
    }
}
